import React from 'react';
import ProductCard from './ProductCard';

const ShopProductGrid = ({ products, onAddToCart, onViewDetail }) => {
  return (
    <section className="container mx-auto p-4 sm:p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onAddToCart={onAddToCart}
            onViewDetail={onViewDetail}   // <-- IMPORTANTE
          />
        ))}
      </div>
    </section>
  );
};

export default ShopProductGrid;
